"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SDKError =
/*#__PURE__*/
function (_Error) {
  _inherits(SDKError, _Error);

  function SDKError(code, packageName, message) {
    var _this;

    _classCallCheck(this, SDKError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SDKError).call(this, message));
    _this.name = 'SDKError';
    _this.code = code;
    _this.packageName = packageName;
    _this.message = message;
    return _this;
  }

  _createClass(SDKError, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.name, " in ").concat(this.packageName, ": ").concat(this.code, ", ").concat(this.message);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        code: this.code,
        message: this.message,
        name: this.name,
        packageName: this.packageName
      };
    }
  }]);

  return SDKError;
}(_wrapNativeSuper(Error));

exports.SDKError = SDKError;